import { Route } from "@angular/router";

export const AddressPaths = {
  Overview: "overzicht",
};

export default [
  { path: "", redirectTo: AddressPaths.Overview, pathMatch: "full" },
  // Fallback
  { path: "all", redirectTo: AddressPaths.Overview, pathMatch: "full" },
  {
    path: AddressPaths.Overview,
    loadComponent: () =>
      import("./pages/address-list/address-list.component").then(
        (comp) => comp.AddressListComponent
      ),
    data: {
      breadcrumb: "Overzicht",
      title: "Organisaties",
      subscriptionTypes: [1, 4, 5],
    },
  },
] satisfies Route[];
